export const KEY = {
  requestIDWeb: "requestIDWeb",
  requestIDSwift: "requestIDSwift",
};
